
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import CertificateRegisterListPage from "../pages/CertificateRegisterListPage";
import CertificateCreatePage from "../pages/CertificateCreatePage";
import CertificateViewPage from "../pages/CertificateViewPage";
import CertificateEditPage from "../pages/CertificateEditPage";

export default function CertificateRoutes() {
  return (
    <Routes>
      <Route index element={<CertificateRegisterListPage />} />

      <Route
        path="new"
        element={<CertificateCreatePage />}
      />

      <Route
        path=":certificateId/edit"
        element={<CertificateEditPage />}
      />

      <Route
        path=":certificateId"
        element={<CertificateViewPage />}
      />

      <Route
        path="*"
        element={
          <Navigate
            to="/assets/certificate-management"
            replace
          />
        }
      />
    </Routes>
  );
}
